import { useCallback } from "react"
import { API_ROUTES } from "../../configuration/RoutesApi"
import { LandingTrackingSettingsEntity } from "../../Objects/Landing/LandingTrackingSettingsEntity"
import { GetRequest } from "../../services/ApiClientService"

export const useGetLandingTracking = () => {
  const handleGetLandingTracking = useCallback(async () => {
    const response = await GetRequest<LandingTrackingSettingsEntity>(API_ROUTES.LANDING.GET_TRACKING)

    if (!response.success) {
      throw new Error(response.message || "Erro ao buscar configurações de rastreamento da landing.")
    }

    return new LandingTrackingSettingsEntity(response.data)
  }, [])

  return { handleGetLandingTracking }
}
